export const GET_LOCATION = Symbol('GET_LOCATION');
export const GET_LOCATION_REQUEST = Symbol('GET_LOCATION_REQUEST');
export const GET_LOCATION_SUCCESS = Symbol('GET_LOCATION_SUCCESS');
export const GET_LOCATION_ERROR = Symbol('GET_LOCATION_ERROR');
